/**
 * UTM parameter capture utilities
 */

export interface UTMParams {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  gclid?: string;
  fbclid?: string;
  msclkid?: string;
}

export function captureUTMParams(): UTMParams {
  if (typeof window === 'undefined') {
    return {};
  }
  
  const params = new URLSearchParams(window.location.search);
  const utm: UTMParams = {};
  
  // Capture standard UTM parameters
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  utmKeys.forEach(key => {
    try {
      const value = params.get(key);
      if (value) {
        utm[key as keyof UTMParams] = value;
      }
    } catch (e) {
      console.error(`UTM: Error getting ${key}:`, e);
    }
  });
  
  // Capture ad platform identifiers
  try {
    const gclid = params.get('gclid');
    if (gclid) {
      utm.gclid = gclid;
    }
    
    const fbclid = params.get('fbclid');
    if (fbclid) {
      utm.fbclid = fbclid;
    }
    
    const msclkid = params.get('msclkid');
    if (msclkid) {
      utm.msclkid = msclkid;
    }
  } catch (e) {
    console.error('UTM: Error getting ad platform IDs:', e);
  }
  
  return utm;
}

export function getStoredUTMParams(): UTMParams {
  if (typeof window === 'undefined') return {};
  
  try {
    const stored = localStorage.getItem('vgfs_utm_params');
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
}

export function storeUTMParams(params: UTMParams): void {
  if (typeof window === 'undefined') return;
  
  try {
    localStorage.setItem('vgfs_utm_params', JSON.stringify(params));
  } catch {
    // Silent fail for localStorage errors
  }
}
